import { OutboundProcess } from '@features/supplyChain/types';
import dayjs from 'dayjs';
import { numberToLocale } from '@forms/client/AddProductForm/utils';
import { despatchLineCount } from '../../../utils/despatch';

interface PickingConfirmationSummaryProps {
  selectedOutboundProcess: OutboundProcess;
  totalPickedItemsQuantity: number | undefined;
  isPickingDiscrepancy: boolean;
  pickingDiscrepancyAmount: number;
  isNegativePickingDiscrepancy: boolean;
  hasProductLines?: boolean;
}

export function PickingConfirmationSummary({
  selectedOutboundProcess,
  totalPickedItemsQuantity,
  isPickingDiscrepancy,
  pickingDiscrepancyAmount,
  isNegativePickingDiscrepancy,
  hasProductLines = false,
}: PickingConfirmationSummaryProps) {
  const lineCount = hasProductLines
    ? despatchLineCount(selectedOutboundProcess.despatchNote)
    : selectedOutboundProcess?.pickingConfirmation?.skus.length;

  return (
    <div className='grid grid-cols-2 gap-x-4 gap-y-3'>
      <div>
        <p className='text-sm font-semibold text-gray-900'>
          {selectedOutboundProcess?.pickingConfirmation?.createdByName}
        </p>
        <p className='text-xs text-gray-400'>Picked by</p>
      </div>
      <div>
        <p className='text-sm font-semibold text-gray-900'>
          {dayjs(
            selectedOutboundProcess?.pickingConfirmation?.actualPickingDate
              .dateTime
          )
            .tz(
              selectedOutboundProcess?.pickingConfirmation?.actualPickingDate
                .timeZone
            )
            .format('DD/MM/YY')}
        </p>
        <p className='text-xs text-gray-400'>Picked date</p>
      </div>
      <div>
        <p className='text-sm font-semibold text-gray-900'>
          {selectedOutboundProcess?.pickingConfirmation?.pickingNoteNumber}
        </p>
        <p className='text-xs text-gray-400'>Picking Note #</p>
      </div>
      <div>
        <p className='text-sm font-semibold text-gray-900'>
          {numberToLocale(lineCount ?? 0)}
        </p>
        <p className='text-xs text-gray-400'>Lines</p>
      </div>
      <div>
        <p className='text-sm font-semibold text-gray-900'>
          {numberToLocale(totalPickedItemsQuantity ?? 0)}
          {isPickingDiscrepancy && (
            <span
              className={
                isNegativePickingDiscrepancy
                  ? 'text-red-600 ml-1'
                  : 'text-gray-900 ml-1'
              }
            >
              ({isNegativePickingDiscrepancy ? '-' : '+'}
              {Math.abs(pickingDiscrepancyAmount)})
            </span>
          )}
        </p>
        <p className='text-xs text-gray-400'>
          {hasProductLines ? 'Total qty (Products)' : 'Total qty (Items)'}
        </p>
      </div>
      {selectedOutboundProcess.pickingConfirmation?.comment && (
        <div className='col-span-2 pt-2'>
          <p className='text-sm text-gray-700'>
            {selectedOutboundProcess.pickingConfirmation.comment}
          </p>
          <p className='text-xs text-gray-400'>Comment</p>
        </div>
      )}
    </div>
  );
}
